import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import { INVITE } from '@/constants/testIds';
import { Copy, Gift, ArrowRight, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const ReferralWidget = () => {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data: d } = await api.get('/referrals/me');
        setData(d);
      } catch (_e) { /* ignore */ }
    })();
  }, []);

  if (!data) return null;

  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const refUrl = `${origin}/r/${data.username}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(refUrl);
      setCopied(true);
      toast.success('Invite link copied!');
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error('Could not copy link');
    }
  };

  return (
    <div data-testid={INVITE.dashboardWidget} className="glass-strong rounded-2xl p-6 border border-white/10 mb-8 relative overflow-hidden">
      <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-fuchsia-500/20 blur-3xl" />
      <div className="relative flex flex-col md:flex-row md:items-center gap-5">
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-[0.3em] text-fuchsia-300 mb-2 flex items-center gap-2">
            <Gift className="h-3 w-3" /> Invite &amp; Earn · rewards coming soon
          </div>
          <div className="text-white font-display text-xl mb-1">Grow your spectrum.</div>
          <div className="text-slate-400 text-sm mb-3">
            <span data-testid={INVITE.widgetSignups} className="text-cyan-300 font-semibold">{data.total_signups}</span>{' '}
            {data.total_signups === 1 ? 'person has' : 'people have'} joined through your link so far.
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <div className="glass border border-white/10 rounded-lg px-3 py-2 font-mono text-xs text-fuchsia-200 truncate max-w-[280px]">
              {refUrl}
            </div>
            <button
              data-testid={INVITE.widgetCopyButton}
              onClick={copyLink}
              className="text-xs glass border border-white/10 hover:border-fuchsia-400/40 transition rounded-lg px-3 py-2 text-slate-200 flex items-center gap-1.5"
            >
              {copied ? <><CheckCircle2 className="h-3 w-3 text-emerald-400" /> Copied</> : <><Copy className="h-3 w-3" /> Copy</>}
            </button>
          </div>
        </div>
        <Link
          to="/invite"
          data-testid={INVITE.widgetOpenButton}
          className="btn-rainbow text-white rounded-full px-5 py-2.5 text-sm flex items-center gap-2 self-start md:self-auto"
        >
          Invite friends <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};

export default ReferralWidget;
